// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"8341b36a","295":"2ae05cb3","617":"903d89cd","686":"4cd5ef5f","831":"15e9594f","950":"21df9bc6"}[chunkId] + ".chunk.css";
};